export default __webpack_public_path__ + "static/media/eth-icon.f1221610.svg";